module.exports = __webpack_public_path__ + "media/frames/frame_white_horizontal-36de781d.jpg";